import { Button, Checkbox, Tooltip } from 'antd';
import React, { PureComponent } from 'react';
import { SettingsContentPanel } from '../../../common/SettingsContentPanel';
import { Flex } from '../../../common/Flex';
import { RegulationReasonType } from 'app/model/CORE';
import MeasureUtils from 'app/common/util/MeasureUtils';
import { CheckboxChangeEvent } from 'antd/es/checkbox';
import Utils from 'app/common/util/Utils';
import { CheckOutlined, ClearOutlined } from '@ant-design/icons';

export const REGULATION_REASONS = Object.keys(RegulationReasonType).map(k => k as RegulationReasonType);

export const DEFAULT_MEASURES_SETTINGS: MeasuresSettings = {
    activeOnly: true,
    monitoredPeriodOnly: false,
    reasons: REGULATION_REASONS,
};

export interface MeasuresSettings {
    activeOnly: boolean;
    monitoredPeriodOnly: boolean;
    reasons: RegulationReasonType[];
}

export class MeasuresSettingsTitle extends PureComponent {
    render() {
        return (
            <Flex direction="vertical">
                <div style={{ fontWeight: 'bold' }}>MEASURES SETTINGS</div>
            </Flex>
        );
    }
}

export class MeasuresSettingsContent extends SettingsContentPanel<MeasuresSettings> {
    render() {
        return (
            <Flex direction="vertical" className="settings-content" style={{ width: '20em', padding: '1em' }}>
                <Flex direction={'vertical'} style={{ alignSelf: 'center' }}>
                    <Flex style={{ paddingBottom: '1em' }}>
                        <Checkbox
                            checked={this.state.activeOnly}
                            onChange={value => this.setState({ activeOnly: value.target.checked })}>
                            Active measures only
                        </Checkbox>
                    </Flex>
                    <Flex style={{ paddingBottom: '1em' }}>
                        <Checkbox
                            checked={this.state.monitoredPeriodOnly}
                            onChange={value => this.setState({ monitoredPeriodOnly: value.target.checked })}>
                            Monitored period only
                        </Checkbox>
                    </Flex>
                    <Flex direction={'vertical'} style={{ gap: '0.5em' }}>
                        <Flex style={{ gap: '1em' }}>
                            <div>Reasons:</div>
                            <Tooltip
                                title="Select all"
                                overlayInnerStyle={{ minHeight: '0' }}
                                overlayStyle={{ paddingBottom: '0' }}
                                showArrow={false}>
                                <CheckOutlined
                                    style={{
                                        visibility:
                                            this.state.reasons.length == REGULATION_REASONS.length
                                                ? 'hidden'
                                                : 'visible',
                                    }}
                                    onClick={() => this.setState({ reasons: REGULATION_REASONS })}
                                />
                            </Tooltip>
                            <Tooltip
                                title="Clear all"
                                overlayInnerStyle={{ minHeight: '0' }}
                                overlayStyle={{ paddingBottom: '0' }}
                                showArrow={false}>
                                <ClearOutlined
                                    style={{ visibility: Utils.isEmpty(this.state.reasons) ? 'hidden' : 'visible' }}
                                    onClick={() => this.setState({ reasons: [] })}
                                />
                            </Tooltip>
                        </Flex>
                        <Flex
                            direction="vertical"
                            style={{
                                gap: '0.5em',
                                height: '10em',
                                overflow: 'auto',
                                border: '0.05em solid #8C8B82',
                                borderRadius: '0.5em',
                                marginLeft: '0.5em',
                                padding: '0.5em 0',
                            }}>
                            {this.renderReasons()}
                        </Flex>
                    </Flex>
                </Flex>
                <Flex style={{ justifyContent: 'space-around' }}>
                    <Button onClick={this.handleApply}>Apply</Button>
                    <Button onClick={this.handleClose}>Close</Button>
                </Flex>
            </Flex>
        );
    }

    private renderReasons = () => {
        return REGULATION_REASONS.map(reason => {
            return (
                <Checkbox
                    style={{ marginLeft: '1em' }}
                    key={reason}
                    checked={this.state.reasons.includes(reason)}
                    onChange={e => this.onReasonCheck(e, reason)}>
                    {MeasureUtils.toRegulationReasonString(reason)}
                </Checkbox>
            );
        });
    };

    private onReasonCheck = (event: CheckboxChangeEvent, reason: RegulationReasonType) => {
        if (event.target.checked) {
            this.setState({ reasons: [...this.state.reasons, reason] });
        } else {
            this.setState({ reasons: this.state.reasons.filter(r => r !== reason) });
        }
    };
}
